"use client";

import { useRef } from "react";
import HomeSection from "./components/HomeSection";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import ShowcaseSection from "./components/ShowcaseSection";
import WhyUsSection from "./components/WhyUsSection";
import ClientsSection from "./components/ClientsSection";
import ContactSection from "./components/ContactSection";

export default function MainPage() {
  const mainRef = useRef<HTMLDivElement | null>(null);

  return (
    <main ref={mainRef} className=' bg-white'>
      <div className=' flex items-center justify-center'>
        <div className='w-full h-full'>
          <HomeSection />
          <AboutSection />
          <ServicesSection />
          <ShowcaseSection />
          <WhyUsSection />
          <ClientsSection />
          <ContactSection />
        </div>
      </div>
    </main>
  );
}
